import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type {
  ExternalProviderRepository,
  SubmitInvoiceBody,
} from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface SubmitExternalProviderInvoiceCommand {
  participationId: string;
  body: SubmitInvoiceBody;
  externalProviderRepository: ExternalProviderRepository;
}

export interface SubmittedInvoiceData {
  invoiceNumber: string;
  invoiceUrl: string;
  amount: number;
  iban: string;
}

export const submitExternalProviderInvoice = createAsyncThunk<SubmittedInvoiceData, SubmitExternalProviderInvoiceCommand>(
  "externalProvider/submitInvoice",
  async ({ participationId, body, externalProviderRepository }: SubmitExternalProviderInvoiceCommand) => {
    await externalProviderRepository.submitInvoice(participationId, body);
    return {
      invoiceNumber: body.invoiceNumber,
      invoiceUrl: body.invoiceUrl,
      amount: body.price,
      iban: body.providerIban,
    };
  },
);

export const resetSubmitExternalProviderInvoice = createAction("externalProvider/resetSubmitInvoice");
